import { Maybe, Supplier } from '@iss/libs/graphql';
import { IfHasPermissionPipe } from '@iss/libs/auth';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { ConditionalLinkComponent } from '../conditional-link';

import { AppRoutingLinks } from '@wo-mc/routing';

@Component({
  selector: 'wo-supplier-link',
  templateUrl: './supplier-link.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    ConditionalLinkComponent,
    IfHasPermissionPipe,
  ],
})
export class SupplierLinkComponent {
  public readonly AppRoutingLinks = AppRoutingLinks;

  @Input() public id: Maybe<Supplier['id']>;
}
